module.exports = __webpack_public_path__ + "static/media/arts_17.fd9892ab.jpg";